<template>
	<div 
		class="design"
		v-loading="loading"
		element-loading-text="拼命加载中"
		element-loading-spinner="el-icon-loading">
		<SurveyDesign v-if="flag" @onChangeFormDataSave="handleFormDataSave" :originData="originData" />
	</div>
</template>

<script>
import Bus from '@/utils/bus';
import SurveyDesign from 'components/SurveyDesign';
import {tagviewsMixins} from '@/utils/mixins.js';
import { mapGetters,mapState, mapMutations } from 'vuex';

export default {
	name: 'BreatheQuestionnaireSurveyDesign',
	mixins:[tagviewsMixins],
	computed: {
		...mapState({
			visitedViews:state => state.tagsView.visitedViews
		})
	},
	components: {
		SurveyDesign
	},
	data() {
		return {
			loading: false,
			originData: {
				formDesign: [],
				formSelect: {}
			},
			flag: false
		}
	},
	created() {
		console.log(this.$route)
		this.getInfo();
	},
	methods: {
		getInfo() {
			this.loading = true;
			this.flag = false;
			this.$api.apiGetSurveyPaperInfo({
				paperId: this.$route.params.id
			}).then(response => {
				if(response.errcode != 0) return;
				this.originData.formInfo = response.data?.surveyPaper;
				this.originData.formDesign = response.data?.surveyQuestionList;
				this.loading = false;
				this.flag = true;
			}).catch(() => {
				this.loading = false;
				this.flag = false;
			});
		},
		handleFormDataSave(data, close) {
			if(close === 'back') {
				// let routeData = this.$store.state.tagsView.visitedViews.find(view=>view.path == this.$route.path);
				// this.closeSelectedTag(routeData);
				this.closeTab(this.$route.path);
				this.$router.go(-1);
				return;
			}
			this.loading = true;
			this.$api.apiPostSurveyPaperCreateUpdate({
				surveyPaper: data.formInfo,
				surveyQuestionList: data.formDesign
			}).then(response => {
				if(response.errcode != 0) {
					this.loading = false;
					return;
				};
				this.$message.success('保存成功');
				this.loading = false;
				if(close === 'close') {
					// let routeData = this.$store.state.tagsView.visitedViews.find(view=>view.path == this.$route.path);
					// this.closeSelectedTag(routeData);
					this.closeTab(this.$route.path);
					this.$router.go(-1);
				}
			});
		},
		closeSelectedTag(view) {
			if(view.path == "/welcome"){
				return
			}
			this.$store.dispatch('tagsView/delView', view).then(({ visitedViews }) => {
				if (this.isActive(view)) {
				this.toLastView(visitedViews, view)
				const latestView = visitedViews.slice(-1)[0];
					if (latestView) {
						this.$router.push(latestView);
					} else {
						this.$router.push("/");
					}
				}
				Bus.$emit("removeCache", "closeSelectedTag", view);
			})
		},
		isActive(route) {
			return route.path === this.$route.path
		},
		toLastView(visitedViews, view) {
			const latestView = visitedViews.slice(-1)[0]
			if (latestView) {
				this.$router.push(latestView.fullPath)
			} else {
				if (view.name === 'Dashboard') {
					this.$router.replace({ path: '/redirect' + view.fullPath })
				} else {
					this.$router.push('/')
				}
			}
		},
	}
}
</script>

<style lang="scss" scoped>
.design {
	width: 100%;
	height: 100%;
	background: #FBFBFC;
	overflow: hidden;
}
</style>